import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import type { NavigateOptions, To } from "react-router-dom";
import { omit, pick } from "lodash-es";

interface NavigateSettings extends NavigateOptions {
  /** 是否退出当前页 */
  close?: boolean;
  /** 是否阻止跳转 */
  block?: boolean;
  /** 是否强制刷新页面 */
  refresh?: boolean;
  target?: '_blank';
};
export const PageNavigateStateName = 'PageNavigateStateName';
const PageNavigatePropsName = ['close', 'block','refresh', 'target'];

export default function usePageNavigate() {
  const navigate = useNavigate();

  const pageNavigate = useCallback((to: To, options?: NavigateSettings) => {
    const customProps = pick(options, PageNavigatePropsName);
    const navigateOptions = omit(options, PageNavigatePropsName) || {};

    navigateOptions.state = {
      ...navigateOptions.state,
      [PageNavigateStateName]: customProps,
    };


    if (options?.refresh) {
      window.location.href = to.toString();
      return true;
    }
    navigate(to, navigateOptions);
  }, [navigate]);
  return pageNavigate;
}
